const SortButton = ({ order, setOrder }) => {
  const toggleSort = () => {
    const newOrder = order === 'asc' ? 'desc' : 'asc';
    setOrder(newOrder);
  };

  return (
    <button className="sort-button" onClick={toggleSort}>
      {order === 'asc' ? (
        <>
          <span className="text-xs">A–Z</span>
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10020_91010)">
              <path
                d="M8.97221 2.42371C8.84719 2.29873 8.67766 2.22852 8.50088 2.22852C8.3241 2.22852 8.15456 2.29873 8.02955 2.42371L4.25821 6.19504C4.19454 6.25654 4.14375 6.3301 4.10881 6.41144C4.07387 6.49277 4.05548 6.58025 4.05471 6.66877C4.05394 6.75729 4.07081 6.84508 4.10433 6.92701C4.13785 7.00894 4.18735 7.08337 4.24995 7.14597C4.31254 7.20856 4.38698 7.25807 4.46891 7.29159C4.55084 7.32511 4.63863 7.34198 4.72715 7.34121C4.81567 7.34044 4.90315 7.32205 4.98448 7.28711C5.06582 7.25217 5.13938 7.20138 5.20088 7.13771L7.83421 4.50437V13.333C7.83421 13.5099 7.90445 13.6794 8.02948 13.8044C8.1545 13.9295 8.32407 13.9997 8.50088 13.9997C8.67769 13.9997 8.84726 13.9295 8.97228 13.8044C9.09731 13.6794 9.16755 13.5099 9.16755 13.333V4.50437L11.8009 7.13771C11.9266 7.25915 12.095 7.32634 12.2698 7.32482C12.4446 7.3233 12.6118 7.25319 12.7354 7.12959C12.859 7.00598 12.9291 6.83877 12.9307 6.66397C12.9322 6.48918 12.865 6.32078 12.7435 6.19504L8.97221 2.42371Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_10020_91010">
                <rect width="16" height="16" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        </>
      ) : (
        <>
          <span className="text-xs">Z–A</span>
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10020_91010)">
              <path
                d="M8.97221 2.42371C8.84719 2.29873 8.67766 2.22852 8.50088 2.22852C8.3241 2.22852 8.15456 2.29873 8.02955 2.42371L4.25821 6.19504C4.19454 6.25654 4.14375 6.3301 4.10881 6.41144C4.07387 6.49277 4.05548 6.58025 4.05471 6.66877C4.05394 6.75729 4.07081 6.84508 4.10433 6.92701C4.13785 7.00894 4.18735 7.08337 4.24995 7.14597C4.31254 7.20856 4.38698 7.25807 4.46891 7.29159C4.55084 7.32511 4.63863 7.34198 4.72715 7.34121C4.81567 7.34044 4.90315 7.32205 4.98448 7.28711C5.06582 7.25217 5.13938 7.20138 5.20088 7.13771L7.83421 4.50437V13.333C7.83421 13.5099 7.90445 13.6794 8.02948 13.8044C8.1545 13.9295 8.32407 13.9997 8.50088 13.9997C8.67769 13.9997 8.84726 13.9295 8.97228 13.8044C9.09731 13.6794 9.16755 13.5099 9.16755 13.333V4.50437L11.8009 7.13771C11.9266 7.25915 12.095 7.32634 12.2698 7.32482C12.4446 7.3233 12.6118 7.25319 12.7354 7.12959C12.859 7.00598 12.9291 6.83877 12.9307 6.66397C12.9322 6.48918 12.865 6.32078 12.7435 6.19504L8.97221 2.42371Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_10020_91010">
                <rect width="16" height="16" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        </>
      )}
    </button>
  );
};

export default SortButton;
